var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera-slash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83301 18.3333H14.5676C16.868 18.3333 17.7848 17.0698 17.8931 15.5297L18.3265 9.35415C18.3765 8.65885 18.1348 8.0084 17.7098 7.5",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0003 5.75027C14.4842 5.75027 14.0103 5.46587 13.7734 5.02709L13.1642 3.84886C12.775 3.10943 11.7596 2.5 10.8966 2.5H8.95892C8.08745 2.5 7.07208 3.10943 6.68286 3.84886L6.07365 5.02709C5.83673 5.46587 5.36289 5.75027 4.84675 5.75027C3.01064 5.75027 1.55529 7.23727 1.67374 8.99242L2.11373 15.7042C2.15604 16.3705 2.33373 16.9962 2.68064 17.5",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.33301 14.425C8.79134 14.7833 9.37467 15 9.99967 15C11.4913 15 12.708 13.7833 12.708 12.2916C12.708 11.7583 12.558 11.2666 12.2913 10.85",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3337 2.5L1.66699 18.3333",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSlash);
export default __webpack_public_path__ + "static/media/camera-slash.a1816838eadf173c9453374ba0a14393.svg";
export { ForwardRef as ReactComponent };